import initialState from './initialState';

let reducers = {

   SET_FRONT_PAGE_FILTER_SUCCESS : (state, payload) => {
     return [Object.assign({}, payload)];
  },

  CLEAR_FRONT_PAGE_FILTER: () =>{
     return [];
  },

  CLEAR_CASE_DATA_PAGE_FILTER: () =>{
    return [];
 }
      
};

export default function frontPageFilter(state = initialState.frontPageFilter, action) {
  let reducer = reducers[action.type];
  return (reducer ? reducer(state, action): state);
}



/** WEBPACK FOOTER **
 ** ./src/reducers/filterFrontpageReducer.js
 **/